import {
  Icon,
  IconBed,
  IconBolt,
  IconBug,
  IconCalendar,
  IconCar,
  IconChecklist,
  IconDoorEnter,
  IconDoorExit,
  IconDroplet,
  IconFlame,
  IconKey,
  IconPaint,
  IconPlant2,
  IconPool,
  IconShieldCheck,
  IconSnowflake,
  IconSun,
  IconTool,
  IconTrash,
  IconWash,
} from '@tabler/icons-react';

import { PROJECT_LABEL_COLORS, ProjectLabel } from 'src/Utils/projectLabelColors';

export const DEFAULT_CHECKLIST_ICON = 'checklist';
export const DEFAULT_CHECKLIST_COLOR = 'sage';

export const CHECKLIST_ICONS: Record<string, Icon> = {
  checklist: IconChecklist,
  sun: IconSun,
  snowflake: IconSnowflake,
  wash: IconWash,
  'door-exit': IconDoorExit,
  'door-enter': IconDoorEnter,
  'plant-2': IconPlant2,
  pool: IconPool,
  bed: IconBed,
  tool: IconTool,
  key: IconKey,
  trash: IconTrash,
  flame: IconFlame,
  droplet: IconDroplet,
  bolt: IconBolt,
  car: IconCar,
  paint: IconPaint,
  bug: IconBug,
  'shield-check': IconShieldCheck,
  calendar: IconCalendar,
};

export const CHECKLIST_ICON_KEYS = Object.keys(CHECKLIST_ICONS);

// Reuses the same palette as project labels (src/Utils/projectLabelColors) for visual consistency.
export const CHECKLIST_COLORS: Record<string, string> = {
  sage: PROJECT_LABEL_COLORS[ProjectLabel.Green].color,
  gold: PROJECT_LABEL_COLORS[ProjectLabel.Yellow].color,
  terracotta: PROJECT_LABEL_COLORS[ProjectLabel.Orange].color,
  bluegray: PROJECT_LABEL_COLORS[ProjectLabel.Blue].color,
  slate: PROJECT_LABEL_COLORS[ProjectLabel.Gray].color,
  verdigris: PROJECT_LABEL_COLORS[ProjectLabel.Purple].color,
  sand: PROJECT_LABEL_COLORS[ProjectLabel.Red].color,
};

export const CHECKLIST_COLOR_KEYS = Object.keys(CHECKLIST_COLORS);

export const resolveChecklistIcon = (key?: string | null): Icon =>
  (key ? CHECKLIST_ICONS[key] : undefined) ?? CHECKLIST_ICONS[DEFAULT_CHECKLIST_ICON];

export const resolveChecklistColor = (key?: string | null): string =>
  (key && CHECKLIST_COLORS[key]) ?? CHECKLIST_COLORS[DEFAULT_CHECKLIST_COLOR];
